import { zfUtils } from "./zf_utils";
export class zfcatm {
    static calcFontSize(num) {
        return zfcatm.baseFontSize - Math.floor(num.toString().length / 3) * 8;
    }
    static numberFormat(num, decimals, thousands_sep, dec_point) {
        var parts = num.toFixed(decimals).split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_sep);
        return parts.join(dec_point);
    }
    static decimalPlaces(num, dec_point) {
        return num.indexOf(dec_point) == -1
            ? 0
            : num.length - num.indexOf(dec_point) - 1;
    }
    static initItem(item) {
        try {
            item.find("img[data-src]").each(function () {
                $(this).attr("src", $(this).data("src"));
            });
            item.find(".zfcatm-count-number").each(function () {
                var that = $(this), numberVal = that.text(), currentNumber, seperatorType = that.data("separator"), decimalType = that.data("decimal"), languageType = that.data("lang"), numDecimals = zfcatm.decimalPlaces(numberVal, decimalType);
                numberVal = parseFloat(languageType == "DE"
                    ? numberVal.replace(RegExp(decimalType, "g"), ".")
                    : numberVal).toFixed(numDecimals);
                that.text(1);
                that.parent().css({
                    fontSize: zfcatm.calcFontSize(Math.round(parseFloat(parseFloat(numberVal.replace(RegExp(seperatorType, "g"), "")).toFixed(numDecimals)))),
                });
                that.init = function () {
                    that.prop("counter", 0).animate({
                        counter: numberVal,
                    }, {
                        duration: zfcatm.duration,
                        step: function (now) {
                            currentNumber = zfcatm.numberFormat(now, numDecimals, seperatorType, decimalType);
                            that.text(currentNumber);
                        },
                    });
                };
                that.init();
            });
            return true;
        }
        catch (err) {
            console.log("Initalization failed: zfcatm.initItem() " + err.message);
        }
    }
    static init() {
        try {
            var readingTimeElement = $(".zfcai-reading-time");
            if (readingTimeElement) {
                var charsPerMin = 1000, totalString = document.body.innerHTML
                    .replace(/<[^>]*>/g, "")
                    .replace(/\n/g, "")
                    .replace(/  /g, "");
                readingTimeElement.text(Math.ceil(totalString.length / charsPerMin) +
                    " " +
                    readingTimeElement.text());
            }
            $(".zfcci-content-image, .zfcsq-single-quote, .zfcatm-article-text-media").each(function () {
                zfUtils.loadOnScroll($(this), "delayZFCATMLoad", zfcatm.initItem, 1);
            });
        }
        catch (err) {
            console.log("Initalization failed: zfcatm.init() " + err.message);
        }
    }
}
zfcatm.baseFontSize = 108;
zfcatm.duration = 2000;
try {
    zfUtils.onReady(zfcatm.init);
}
catch (err) {
    console.log("Initalization failed: zfcatm.init() " + err.message);
}
